import { Component, Input, OnInit, SimpleChanges,ViewEncapsulation  } from '@angular/core';
@Component({
  selector: 'app-featured-content',
  templateUrl: './app-featured-content.component.html',
  styleUrls: ['./app-featured-content.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppFeaturedContent implements OnInit {

  @Input() dataReport: any
  title_report = 'Top nội dung báo chí';
  topTopicContent = '';
  topics = []

  constructor() {
  }

  ngOnInit(): void {
  };

  ngOnChanges(changes: SimpleChanges) {
    this.mappingData()
  }
 
  async mappingData() {
    console.log(this.dataReport.data)
    if(this.dataReport && this.dataReport.data) {
      if(this.dataReport.report_title) {
        this.title_report = this.dataReport.report_title;
      }
      if(this.dataReport.data.topics) {
        const res = this.dataReport.data.topics.sort((a, b) => parseFloat(a._source.count) - parseFloat(b._source.count));
          this.topics = res; 
      }
      if(this.dataReport.data.topTopicContent) {
        this.topTopicContent = this.dataReport['data'].topTopicContent;
      }

    }
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-component/featured-content/app-featured-content.component.ts